/** Expands/collapses the "+ Show more" toggle for .pdm-ul lists with more than 6 values. */
document.addEventListener('DOMContentLoaded', () => {
  const showMoreBtns = document.querySelectorAll('.pdm-show-more-btn');
  showMoreBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const ul = btn.previousElementSibling;
      if (ul && ul.classList.contains('pdm-ul')) {
        const isOpen = ul.dataset.open === 'true';
        if (!isOpen) {
          ul.style.maxHeight = ul.scrollHeight + 'px';
          ul.dataset.open = 'true';
          btn.textContent = '- Show less';
        } else {
          ul.style.maxHeight = '';
          ul.dataset.open = 'false';
          btn.textContent = '+ Show more';
        }
      }
    });
  });
});
